import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, AdminRoute } from "@/components/Routes";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import { ForgotPassword, ResetPassword } from "@/pages/ForgotReset";
import Dashboard from "@/pages/Dashboard";
import ModulePage from "@/pages/ModulePage";
import PaymentResult from "@/pages/PaymentResult";
import CompliancePage from "@/pages/CompliancePage";
import Certificate from "@/pages/Certificate";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Emergent Google OAuth returns with #session_id=... — handle it before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/compliance" element={<CompliancePage />} />
      <Route path="/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentResult mode="success" />} />
      <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/module/:id" element={<ProtectedRoute><ModulePage /></ProtectedRoute>} />
      <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
